import React from "react";
import NavBar from "./components/NavBar/NavBar";
import LandingPage from "./components/LandingPage/LandingPage";
import Intro from "./components/Intro/Intro";
import Projects from "./components/Projects/Projects";
import Photos from "./components/Photos/Photos";
import Blog from "./components/Blog/Blog";
import Subscription from "./components/Subscription/Subscription";
import Footer from "./components/Footer/Footer";
import { Element} from 'react-scroll';

function App() {
  return (
    <div>
      {LandingPage(
        <>
          <NavBar />
          <div style={{ height: "120vh" }} />
          <Element name = "intro"><Intro/></Element>
          <Element name = "projects"><Projects/></Element>
          <Element name = "photos"><Photos/></Element>
          <Element name = "blogs"> <Blog /></Element>
          <Subscription/>
          <Footer/>
        </>
      )}
    </div>
  );
}

export default App;
